import type { AddOn, Company, Service } from '../types';

export const getTierPrice = (
  item: Service | AddOn,
  options?: {
    company?: Company | null;
    isCorporate?: boolean;
  }
) => {
  const normalize = (value: number | string | null | undefined) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const company = options?.company || null;
  const tier = company?.tier;
  const isCorporate = options?.isCorporate ?? Boolean(company);
  const tierValue = tier ? item.tierPrices?.[tier] : null;

  if (isCorporate && item.tierPrices && tierValue != null) {
    return normalize(tierValue);
  }

  return normalize(item.price);
};
